exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".plusIcon-28e3d478{border:2px solid #E0E0E0;border-radius:50%;display:block;margin:0 auto;background:#FFF;object-fit:cover}\n", ""]);

// Exports
exports.locals = {
	"plusIcon": "plusIcon-28e3d478"
};